import * as Yup from 'yup';
import { CasesGeneralInformation } from '../../../../../../shared/types/modules/cases-general-information';

export const initialValues: CasesGeneralInformation = {
    callId: '',
    channel: '',
    typification1: '',
    typification2: '',
    typification3: '',
    typification4: '',
    typification5: '',
    observation: '',
    isTransferAssistance: false,
    document: '',
    vehiclePlate: '',
    policyNumber: '',
    branch: '',
    userAttendanceId: '',
    userAttendanceName: '',
};

export const validationSchema = (
    requireTypification2: boolean,
    requireTypification3: boolean,
    requireTypification4: boolean,
    requireTypification5: boolean,
    isTracking: boolean,
    isAutomobilesTypification: boolean,
    avisoSiniestroTypification2Id?: string,
    userAttendanceRequired?: boolean
) => {
    const schema: any = {
        callId: Yup.string()
            .max(
                100,
                'El call ID debe tener 100 caracteres alfanuméricos como máximo'
            )
            .required('El call ID es obligatorio'),
        channel: Yup.string().required('El canal es obligatorio'),
        typification1: Yup.string().required(
            'La tipificación 1 es obligatoria'
        ),
        observation: Yup.string().required('La observación es obligatoria'),
    };

    if (requireTypification2)
        schema.typification2 = Yup.string().required(
            'La tipificación 2 es obligatoria'
        );
    if (requireTypification3)
        schema.typification3 = Yup.string().required(
            'La tipificación 3 es obligatoria'
        );
    if (requireTypification4)
        schema.typification4 = Yup.string().required(
            'La tipificación 4 es obligatoria'
        );
    if (requireTypification5)
        schema.typification5 = Yup.string().required(
            'La tipificación 5 es obligatoria'
        );
    if (isTracking) {
        schema.document = Yup.string().when('typification2', {
            is: (typification2: string) =>
                isAutomobilesTypification &&
                Boolean(avisoSiniestroTypification2Id) &&
                typification2 === avisoSiniestroTypification2Id,
            then: (fieldSchema: Yup.StringSchema) =>
                fieldSchema.required('Número de documento es obligatorio'),
            otherwise: (fieldSchema: Yup.StringSchema) => fieldSchema,
        });
        schema.vehiclePlate = Yup.string().when('typification2', {
            is: (typification2: string) =>
                isAutomobilesTypification &&
                Boolean(avisoSiniestroTypification2Id) &&
                typification2 === avisoSiniestroTypification2Id,
            then: (fieldSchema: Yup.StringSchema) =>
                fieldSchema.required('Placa es obligatoria'),
            otherwise: (fieldSchema: Yup.StringSchema) => fieldSchema,
        });
        schema.policyNumber = Yup.string().when('typification2', {
            is: (typification2: string) =>
                isAutomobilesTypification &&
                Boolean(avisoSiniestroTypification2Id) &&
                typification2 === avisoSiniestroTypification2Id,
            then: (fieldSchema: Yup.StringSchema) =>
                fieldSchema.required('Número de póliza es obligatorio'),
            otherwise: (fieldSchema: Yup.StringSchema) => fieldSchema,
        }); 
        schema.branch = Yup.string().required('La sucursal es obligatoria');
    }

    if (userAttendanceRequired) {
        schema.userAttendanceId = Yup.number()
            .typeError('El ID de atención al usuario debe ser un número válido')
            .min(0, 'El ID de atención al usuario no puede ser negativo')
            .required('El ID de atención al usuario es obligatorio');
        schema.userAttendanceName = Yup.string().required(
            'El nombre de atención al usuario es obligatorio'
        );
    }
    return Yup.object(schema);
};
